const ecpIntroRoutes = [
  {
    path: "ecpIntro", // ecpIntro
    meta: {
      title: "비교과제도",
      titleEn: "ECP Intro",
      isDynamic: true,
      menuCd: "CLIENT_ECP_INTRO",
    },
    component: () => import("@/views/ecpIntro/EcpIntroIndex.vue"),
  },
];
export default ecpIntroRoutes;
